<script lang="ts">
    import { InputType } from "../../types/Input";

    export let id: string = "";
    export let label: string = "";
    export let type: InputType = "text";
    export let placeholder: string = "";
    export let value: string | number | undefined;
    export let required: boolean = false;
    export let autocomplete: string | undefined;

    function handleInput(e: Event) {
        const target = e.target as HTMLInputElement;
        value = target.type === "number" ? Number(target.value) : target.value;
    }
</script>

<div class="mb-4">
    <label for={id} class="block text-sm font-medium text-gray-700 mb-1">
        {label}
    </label>

    <input
        {id}
        {type}
        {value}
        {placeholder}
        {required}
        {autocomplete}
        on:input={handleInput}
        class="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
    />
</div>
